exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mobile-filter-options .filter-trigger-container{position:fixed;left:0;right:0;bottom:0;z-index:999}#mobile-filter-options .filter-trigger-container .btn{border-radius:10px 10px 0 0;padding:15px 25px;width:100%}#mobile-filter-options #mobile-filter-container{bottom:0;position:fixed;left:0;right:0;z-index:999}#mobile-filter-options #mobile-filter-container .card{border-radius:30px 30px 0 0;overflow:hidden}#mobile-filter-options #mobile-filter-container .card .card-body.scrollable{max-height:60vh;overflow-y:auto;overflow-x:hidden;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/js/react/components/ToursIndex/styles/style.scss
// module id = tk/p
// module chunks = 0